import React, { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMapEvents,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Box } from "@mui/material";
import L from "leaflet";

function MapComponent({
  selectedPosition,
  onLocationChange,
  data,
  drag
}) {
  const [markerPosition, setMarkerPosition] = useState(selectedPosition);

  useEffect(() => {
    if (selectedPosition) {
      setMarkerPosition(selectedPosition);
    }
  }, [selectedPosition]);

  const getTimeZone = async (lat, lng) => {
    try {
      const username = "hunaiza";
      const response = await fetch(
        `http://api.geonames.org/timezoneJSON?lat=${lat}&lng=${lng}&username=${username}`
      );
      const data = await response.json();
      return data?.timezoneId || "Unknown";
    } catch (error) {
      console.error("Error fetching time zone:", error);
      return "Unknown";
    }
  };

  const reverseGeocode = async (lat, lng) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
      );
      const data = await response.json();

      const address = data?.address || {};

      const city =
        address.city ||
        address.town ||
        address.village ||
        address.hamlet ||
        "Unknown City";

      const country = address.country || "Unknown Country";

      return {
        city,
        district: address.state || "Unknown District",
        country,
        formattedAddress: data.display_name || "",
        timeZone: await getTimeZone(lat, lng),
      };
    } catch (error) {
      console.error("Error fetching address:", error);
      return {
        city: "Unknown City",
        district: "Unknown District",
        country: "Unknown Country",
        formattedAddress: "",
        timeZone: "Unknown",
      };
    }
  };

  // const reverseGeocode = async (lat, lng) => {
  //   try {
  //     const response = await fetch(
  //       `https://dev.virtualearth.net/REST/v1/Locations/${lat},${lng}?key=AtPZpJTj7Gc4wSv2RUZ_b0zI0B22uXVJGYsNZyyP6wmMUVEnoQwcIuAzLYKbKaQy`
  //     );
  //     const data = await response.json();
  //     const address = data?.resourceSets[0]?.resources[0]?.address;

  //     if (address) {
  //       const city =
  //         address.locality ||
  //         address.adminDistrict2 ||
  //         address.adminDistrict ||
  //         "Unknown City";

  //       const country =
  //         address.countryRegion ||
  //         address.country ||
  //         "Unknown Country";

  //       return {
  //         city,
  //         district: address.adminDistrict || "Unknown District",
  //         country,
  //         formattedAddress: address.formattedAddress || '',
  //         timeZone: await getTimeZone(lat, lng),
  //       };
  //     }
  //   } catch (error) {
  //     console.error("Error fetching address:", error);
  //   }

  //   return {
  //     city: "Unknown City",
  //     district: "Unknown District",
  //     country: "Unknown Country",
  //     formattedAddress: "",
  //     timeZone: "Unknown",
  //   };
  // };

  const customIcon = L.divIcon({
    className: "custom-marker",
    html: `
      <div style="display: flex; align-items: center; justify-content: center; color: red; font-size: 54px;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red" width="54px" height="54px">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 3.88 3.06 7.23 7.37 11.54.39.4 1.02.4 1.41 0C15.94 16.23 19 12.88 19 9c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/>
        </svg>
      </div>
    `,
    iconSize: [52, 52],
  });

  const AutoMoveMap = () => {
    const map = useMap();
    useEffect(() => {
      if (markerPosition) {
        map.flyTo(markerPosition, 14, { animate: true, duration: 1.5 });
      }
    }, [markerPosition, map]);
    return null;
  };

  const LocationMarker = () => {
    useMapEvents({
      click: async (e) => {
        if (drag) return;

        const { lat, lng } = e.latlng;
        setMarkerPosition([lat, lng]);

        const address = await reverseGeocode(lat, lng);
        if (onLocationChange) {
          onLocationChange(address);
        }
      },
    });

    return markerPosition ? <Marker position={markerPosition} icon={customIcon} /> : null;
  };

  return (
    <Box sx={{ borderRadius: "8px", mt: 4, width: "100%", height: { md: "500px", xs: "400px" } }}>
      <MapContainer
        center={selectedPosition}
        zoom={6}
        style={{ height: "100%", width: "100%" }}
        attributionControl={false}
        zoomControl={!drag}
        scrollWheelZoom={!drag}
        doubleClickZoom={!drag}
        dragging={!drag}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <AutoMoveMap />
        <LocationMarker />
        {markerPosition && <Marker position={markerPosition} icon={customIcon} />}
      </MapContainer>
    </Box>
  );
}

export default MapComponent;
